import { extendTheme } from "@chakra-ui/react";

const CustomColorScheme = extendTheme({
    colors: {
        blueAlpha: {
            100: "rgba(42, 67, 101, 0.1)"
        }
    }
})

export default CustomColorScheme;